import * as React from 'react';
import chevronDownPng from '../../../images/chevronDown.png';

const ExpandOrCollapseButton = ({ expanded, onClick }: Props) => {
	const buttonTitle = expanded ? 'Collapse' : 'Expand';
	const iconClassName = expanded ? 'chevronUpIcon' : '';
	return (
		<button title={buttonTitle} className="iconButton expandOrCollapseButton" type="button" onClick={onClick}>
			<img className={iconClassName} src={chevronDownPng} alt="Expand or Collapse Icon" />
		</button>
	);
};

interface Props {
	expanded: boolean;
	onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export default ExpandOrCollapseButton;
